import Home from '../Pages/Home/Home'
import Leave from '../Pages/Leave/Leave'
import Profile from '../Pages/Profile/Profile';
import Timesheets from '../Pages/Timesheets/Timesheets'
import DevelopmentMode from '../Pages/DevelopmentMode/DevelopmentMode'

const authProtectedRoutes = [
    { path: "/", component: <Home /> },
    { path: "/leave", component: <DevelopmentMode /> },
    { path: "/report", component: <DevelopmentMode /> },
    { path: "/profile", component: <DevelopmentMode /> },
  ];
  
  const publicRoutes = [
    { path: "/404", component: <Timesheets /> },
  ];

export {authProtectedRoutes, publicRoutes};